import { useState } from "react";
import { AdminModules } from "../features";
import { gql, useMutation } from "@apollo/client";
import { useApolloQuery } from "../../../../hooks";
import { useAuthSession } from "../../../../components/AuthSessionProvider";
import { useNotify } from "../../../../components/@common/NotificationsProvider";
import { useNavigate } from "react-router-dom";
import {
  ConfirmationDeleteModal,
  useLanguageTranslator,
} from "../../../../components";
import dayjs from "dayjs";

const GET_GEOGRAPHICAL_AREAS = gql`
  query GetGeographicalAreas($page: Int!) {
    geographicalAreasWithPagination(page: $page) {
      collection {
        id
        name
        createdAt
        updatedAt
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

const DELETE_GEOGRAPHICAL_AREA = gql`
  mutation geographicalAreaDelete($id: ID!) {
    geographicalAreaDelete(input: { id: $id }) {
      clientMutationId
      geographicalArea {
        id
        name
        createdAt
        updatedAt
      }
    }
  }
`;

function GeographicalArea() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isOpenDelete, setIsOpenDelete] = useState({ status: false, data: {} });

  const { user } = useAuthSession() as any;
  const notify = useNotify();
  const navigate = useNavigate();
  const { translator } = useLanguageTranslator();

  const { data, loading, refetch } = useApolloQuery({
    queryDocument: GET_GEOGRAPHICAL_AREAS,
    isPrivateCall: true,
    variables: {
      page: page,
    },
  });

  const [deleteGeographicalArea, { loading: deleteLoading, error }] =
    useMutation(DELETE_GEOGRAPHICAL_AREA, {
      context: {
        headers: {
          "access-token": user?.accessToken,
          client: user?.client,
          uid: user?.email,
        },
      },
    });

  const modifiedGetGeoGraphicalArea =
    data?.geographicalAreasWithPagination?.collection?.map(
      (item: any) => {
        return {
          sr: item?.id,
          id: item?.id,
          name: item?.name,
          createdAt: dayjs(item?.createdAt?.split("T")?.[0] || "").format(
            "DD.MM.YYYY"
          ),
          updatedAt: dayjs(item?.updatedAt?.split("T")?.[0] || "").format(
            "DD.MM.YYYY"
          ),
        };
      }
    );

  async function onClickHandler(type: string, clickedId: any) {
    if (type === "edit") {
      navigate(`/admin/geographical-area/update?id=${clickedId}`);
      return;
    }

    if (type === "delete") {
      setIsOpenDelete({ status: true, data: { id: clickedId } });
    }
  }

  async function onClickDeleteHandler(item: any) {
    const response = await deleteGeographicalArea({
      variables: { id: Number(item?.id) },
    });
    if (response?.data) {
      notify.success(`${translator("Geographical Area")} Delete successfuly!`);
      setIsOpenDelete({ status: false, data: {} });
      setTimeout(async () => {
        await refetch();
      }, 1000);
    }
  }

  function handleDeleteClose() {
    setIsOpenDelete({ status: false, data: {} });
  }

  return (
    <>
      <ConfirmationDeleteModal
        isOpen={isOpenDelete?.status}
        item={isOpenDelete?.data}
        onClickHandler={onClickDeleteHandler}
        handleClose={handleDeleteClose}
      />
      <AdminModules
        title={translator("Geographical Area")}
        path="/admin/geographical-area/add-new"
        data={modifiedGetGeoGraphicalArea}
        moduleKey="GeographicalArea-module"
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setPage={setPage}
        onClickHandler={onClickHandler}
        metadata={data?.geographicalAreasWithPagination?.metadata || {}}
      />
    </>
  );
}

export { GeographicalArea };
